import React, { Component } from 'react'
import { getUser } from '~/redux/user/helpers'
import ListItemTiles from '~/components/ListItemTiles'
import RequireAuth from '~/components/RequireAuth'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import Spinner from "~/components/Spinner";
import { getTransactionInfo } from '~/redux/uservideo/helpers.js'
import _ from 'lodash'
import "./styles.css";

class LibraryByType extends Component {	
	constructor(props){
	super(props)
		this.state = { 
			dataList: null,
			fetching: true,
			noData: false
		}
	}
	componentDidMount(){
		this.fetchData()
	}
	fetchData = () => {
		getUser((user) => {
			if (user) {
				return getTransactionInfo(user.userId, true )
				.then((res) => {
					if(res && res.data.records.length > 0){
					let content = []
					let dataList = []
					Object.keys(res.data.records).forEach(key => {
						content.push(res.data.records[key].contentResponse.gist)
						content[key].contentType = res.data.records[key].contentResponse.contentType || res.data.records[key].contentResponse.gist.contentType
						content[key].contentType = content[key].contentType === "SEASON" ? 'SERIES' : content[key].contentType;
						content[key].contentType = content[key].contentType === "BUNDLE" ? 'SERIES' : content[key].contentType;
						content[key].contentType = (content[key].contentType === "VIDEO" && content[key].mediaType === undefined) ? 'VIDEOS' : content[key].contentType;
						content[key].contentType = (content[key].contentType === "video"  && content[key].mediaType === undefined )? 'VIDEOS' : content[key].contentType;
						content[key].contentType = (content[key].contentType === "VIDEO"  && content[key].mediaType === 'EPISODIC' )? 'PROGRAMS' : content[key].contentType;
						content[key].contentType = (content[key].contentType === "video"  && content[key].mediaType === 'EPISODIC' )? 'PROGRAMS' : content[key].contentType;
						content[key].contentType = content[key].contentType === "bundle" ? 'SERIES' : content[key].contentType;
					})
					var groupedContent = _.groupBy(content, 'contentType')
					Object.keys(groupedContent).forEach(key => {
						dataList[key] = {
							...this.props,
							items:groupedContent[key]
						}
					})
					this.setState({ dataList: dataList, fetching:false })
				}else{
					this.setState({ noData:true, fetching:false })
				}
				})
			}
		})
	}	

	render() {
		const titleColor = _.get(window.settings, "brand.general.blockTitleColor");
		return (
			<RequireAuth user={this.state.user}>
				<div className="pageTitle" style={{ color: titleColor }}>My Library</div>
				{this.state.dataList && Object.keys(this.state.dataList).map((key, i) => (
					<ListItemTiles fetching={this.state.fetching} key={i} header={key === "SERIES" ? "Bundles & Series" : key} {...this.state.dataList[key]} />
				))}
				{this.state.fetching && <Spinner />}
				{this.state.noData && <div className="noData">Your list is Empty!</div>}
			</RequireAuth>
		)
	}
}


connect(LibraryByType, (state) => ({ user: state.user }), userStore)

export default LibraryByType;